export const PREVIEW_LANGUAGES = [
    { code: 'pl', originalLabel: 'Polski' },
    { code: 'en', originalLabel: 'English' },
    { code: 'it', originalLabel: 'Italiano' },
    { code: 'es', originalLabel: 'Español' },
    { code: 'ja', originalLabel: '日本語' },
];

export const I18N_SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'pl', label: 'Polski' },
];
